import { Box, Input } from '@chakra-ui/react';
import { MdSearch } from 'react-icons/md';

export function SearchInput({ placeholder }: { placeholder?: string }) {
  return (
    <Box w="100%" maxW="360px" mt="32px">
      <Box position="relative">
        <Input
          placeholder={placeholder ?? 'Search by Generic Name'}
          borderRadius="full"
          borderColor="#e5e5e5"
          borderWidth="2px"
          fontSize="16px"
          fontWeight={400}
          color="#8b8b8b"
          h="48px"
          pl="16px"
          pr="48px"
          _placeholder={{ color: '#8b8b8b' }}
        />
        <Box position="absolute" right="16px" top="50%" transform="translateY(-50%)" color="#ccccd6">
          <MdSearch size="24px" />
        </Box>
      </Box>
    </Box>
  );
}